// extracted by mini-css-extract-plugin
export default {"iframe":"index-module__exvZp","mobileWraper":"index-module__f9ioW","hideOnMobile":"index-module__CO2Lr","registerWrapper":"index-module__g6QHu","backToWebsite":"index-module__HXqvc"};